import PropTypes from "prop-types"
import React from "react"
import {FormGroup, Label} from "reactstrap"
import AsyncSelect from "react-select/async"
import { useTranslation } from "react-i18next"
import useCarregarOpcoes from "./use-carregar-opcoes"


const FormFilterAsyncSelect = props => {
    const { attribute, placeholder, description, value, setValue, multiple, searchOptions, dependencyKey, noOptionsMessage } = props
    const { t } = useTranslation()
    const { carregarOpcoes, falhou } = useCarregarOpcoes(searchOptions)

    return (
        <React.Fragment>
            <FormGroup className="mt-3 mb-0">
                <Label htmlFor={ (attribute || 'filter') + "-async-select" }>
                    { description || ( 'Campo' + (multiple ? '(s)' : '')) }
                </Label>
                <AsyncSelect
                    key={ dependencyKey }
                    id={ (attribute || 'filter') + "-async-select" }
                    name={ (attribute || 'filter') + "-async-select" }
                    className="basic-single"
                    placeholder={ placeholder || `Digite o ${description}...` }
                    isClearable={ true }
                    isSearchable={ true }
                    isMulti={ multiple }
                    value={ value }
                    noOptionsMessage={ () => falhou ? t("formulario.busca.erro") : (noOptionsMessage || `Nenhum(a) ${description} encontrado(a)`) }
                    loadingMessage={ () => "Carregando" }
                    onChange={ e => {
                        setValue(e)
                    }}
                    cacheOptions
                    loadOptions={ carregarOpcoes }
                    defaultOptions
                    styles={{
                        menu: (base) => ({
                            ...base,
                            'z-index': '2'
                        }),
                    }}
                />
            </FormGroup>
        </React.Fragment>
    )
}

FormFilterAsyncSelect.propTypes = {
    attribute: PropTypes.string,
    description: PropTypes.string,
    placeholder: PropTypes.string,
    multiple: PropTypes.bool,
    value: PropTypes.any,
    setValue: PropTypes.func,
    searchOptions: PropTypes.func,
    dependencyKey: PropTypes.any,
    noOptionsMessage: PropTypes.string
}

export default FormFilterAsyncSelect
